import React from "react";

/**
 * Min-sheet-unit glyph (CalcMethod) — the smallest board unit you can buy, like the configurator's
 * CALC_METHOD_ICONS but drawn as a crisp sheet-fraction SVG instead of a unicode glyph.
 * Full = whole sheet, Half, Quarter, Area/SquareMeter = priced by m².
 */
const TITLES: Record<string, string> = {
    Full: "Egész tábla",
    Half: "Fél tábla",
    Quarter: "Negyed tábla",
    Area: "m² alapú árazás",
    SquareMeter: "m² alapú árazás",
};

const SheetIcon: React.FC<{ cm?: string | null }> = ({ cm }) => {
    if (!cm) return null;
    let fill: React.ReactNode = null;
    if (cm === "Full") fill = <rect x="1.7" y="1.7" width="12.6" height="8.6" rx="0.6" fill="currentColor" opacity=".8" />;
    else if (cm === "Half") fill = <rect x="1.7" y="1.7" width="6.1" height="8.6" fill="currentColor" opacity=".8" />;
    else if (cm === "Quarter") fill = <rect x="1.7" y="1.7" width="6.1" height="4.1" fill="currentColor" opacity=".8" />;
    else if (cm === "Area" || cm === "SquareMeter")
        fill = <path d="M2.5 9.5 L9.5 2.5 M5.5 10.3 L13.3 2.5 M9 10.3 L13.3 6" stroke="currentColor" strokeWidth=".9" opacity=".75" fill="none" />;

    return (
        <span title={TITLES[cm] || cm} style={{ color: "#5a6b48", display: "inline-flex", flex: "0 0 auto" }}>
            <svg viewBox="0 0 16 12" width="15" height="12" aria-hidden="true">
                <rect x="1" y="1" width="14" height="10" rx="1" fill="none" stroke="currentColor" strokeWidth="1" />
                {fill}
            </svg>
        </span>
    );
};

export default SheetIcon;
